import { type PaginatedRequest } from "../../api/pagination";
import { Age } from "../attributes/UserAgeAttributeSet";
import { Height } from "../attributes/UserHeightAttributeSet";
import { Weight } from "../attributes/UserWeightAttributeSet";

import { FilterType } from "@/schemas/screen/filters/FilterCriteria";
import { type FilterByRange } from "@/schemas/screen/filters/FilterByRange";

export type UserFilterCriteria = {
  type: FilterType.USER;
  age: FilterByRange<Age> | null;
  height: FilterByRange<Height> | null;
  weight: FilterByRange<Weight> | null;
  hasAvatar: boolean | null;
  exclude: string[] | null;
};

export type UserFilterCriteriaRequest = {
  filter: UserFilterCriteria;
  page: PaginatedRequest | null;
};

export const InitialFilterCriteria: UserFilterCriteria = {
  type: FilterType.USER,
  age: null,
  height: null,
  weight: null,
  exclude: null,
  hasAvatar: null,
};
